<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Ledger/Party Fields</v-toolbar-title>

		    <v-spacer></v-spacer>

			<v-btn round-borders outline @click="fn_checkValidations">save</v-btn>

		</v-toolbar>

		<v-form class="form-element hasToolbar grey-back">

            <v-layout wrap padding-top-bottom-ten white-background>
			  	<!-- <v-flex xs12 sm12 md12 form-item>
		           <v-text-field  v-model="Form.accountGroupName" label="Account Group" placeholder=" " :disabled="true" v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		        </v-flex> -->

                <v-flex xs12 sm12 md12 form-item @click="fn_openAccountGroupsDialog('android', 'AccountGroups', 'field_accountGroups')">

                    <v-text-field  
                        readonly 
                        v-model="Form.accountGroupName" 
                        label="Account Group" 
                        placeholder=" "
                        append-icon="arrow_drop_down"
                        ref="field_accountGroups" 
                        :onUpdate="fn_updateAccountGroup" 
                        v-validate="'required'" 
                        data-vv-name="account group"
                        :error-messages="errors.collect('account group')" 
                        required>
                    </v-text-field>
                </v-flex>

				<v-flex xs12 sm12 md12 form-item v-if="Form.nearestAccountGroupName">
					<v-chip small>Fields inherited from {{ Form.nearestAccountGroupName }}</v-chip>
				</v-flex>

                <v-flex xs12 sm12 md12 form-item v-if="Form.accountGroupId && Form.accountGroupId != 'e39f5778-d5c4-4812-a035-7924dd91156d' && Form.accountGroupId != 'e755d16a-21f0-4c99-82e7-6be3bd2765e5'">
                    <v-checkbox label="Customize Fields" v-model="Form.isCustomized" @change="fn_openDialogConfirmation"></v-checkbox>
                </v-flex>
            </v-layout>

			<div class="mt-2" v-if="Form.fieldItems && Form.fieldItems.length">
                <!-- Dynamic Fields -->
                <field-items 	
                    ref="ref_fieldItems"
					:isCustomized="Form.isCustomized"
                    :fieldItems="Form.fieldItems"
                    :openFieldListDialog="$refs['ref_fieldsForm'].fn_openFieldList"
                    :openSectionList="$refs['ref_fieldsForm'].fn_openSectionList"
                    :openSectionForm="$refs['ref_fieldsForm'].fn_openSectionForm"
                    :editField="$refs['ref_fieldsForm'].fn_editField"
                    :removeField="$refs['ref_fieldsForm'].fn_removeField"
                    :openMoveFieldDialog="$refs['ref_fieldsForm'].fn_openMoveFieldDialog"
                    :editSection="$refs['ref_fieldsForm'].fn_editSection"
                    :openReorderSectionDialog="$refs['ref_fieldsForm'].fn_openReorderSectionDialog"
                    :key="fieldItemsComponentKey">
                </field-items>
            </div>
			

		</v-form>

	    <v-snackbar v-model="snackbar" :timeout="3000">
	    	<div v-html="snackbar_msg"></div>
	    </v-snackbar>

	    <div>
			<field-form 
				ref="ref_fieldsForm" 
				:isAccountGroup="true">
			</field-form>
		 </div>

	    <dialog-field-list 
	    	v-if="$refs['ref_fieldsForm']"
	    	ref="ref_fieldList" 
	    	:setFieldValue="$refs['ref_fieldsForm'].fn_setFieldValue"
	    	:getFieldData="$refs['ref_fieldsForm'].fn_getFieldData"
			:isAccountGroup="true">
	    		
	    </dialog-field-list>

		<dialog-move-field 
	    	ref="ref_moveField" 
	    	:moveField="$refs['ref_fieldsForm'].fn_moveField"
	    	:closeMoveFieldDialog="$refs['ref_fieldsForm'].fn_closeMoveFieldDialog" 
	    	v-if="$refs['ref_fieldsForm']">
	    		
	    </dialog-move-field>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

		<dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="fn_resetFields" :cancelMethod="fn_cancelCustomizeToggle" okBtnText="Okay" cancelBtnText="Cancel"></dialog-confirmation>
	</div>
</template>

<script>

const dialogjs =  require('../../masters/forms/dialog.js').dialogjs;
const menuItem = require('../../../config.js').configs.menuItem;
const accountGroupIds = require('../../../config.js').configs.accountGroupIds;

import fieldForm from '../../fields/dialog_field_form';
import fieldList from '../../fields/dialog_field_list';
import moveFieldDialog from '../../fields/dialog_move_field';
import fields from '../../fields/fields_copy_account_group';

import dialogDiscard from '../../dialogs/dialog_discard'
import dialogConfirmation from '../../dialogs/dialog_confirmation'

import {draftMixin} from '../../draft_mixin.js'


	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"fieldData":JSON.parse(JSON.stringify(require('../../fields/datamodel.js').data.fieldData)),
                    "accountGroupSettingsId":null,
					"accountGroupId":null,
                    "accountGroupName":null,
					"additionalData":null,
                    "fieldItems":[],
					"isCustomized":false,
					"nearestAccountGroupName":null,
					"isInherited":false,
					"settingData":null,
					"inheritedData":null
				},

				formId:null,
				dialogStorageId:null,
				draftStorageId:null,
				backButtonPress:false,
				snackbar:false,
				snackbar_msg:null,
				unwatch:false,
				// fieldLIstDialogKey:this.guidWeb(),
				isLoading:false,
                fieldItemsComponentKey:null,
				confirmationHeader:null,
				confirmationMessage:null
			}
		},
		components:{
			// 'dialog-section-form': sectionForm,
			'dialog-field-list': fieldList,
			// 'dialog-section-list': sectionList,
			'field-form': fieldForm,
			'field-items': fields,
			'dialog-move-field': moveFieldDialog,
			// 'dialog-reorder-section': reorderSectionDialog,
			'dialog-discard': dialogDiscard,
			'dialog-confirmation':dialogConfirmation,
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
						 this.fn_saveDraft(this.draftStorageId);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		methods:{

            fn_openParentGroupsDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;


				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Account Group";
				// viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountGroupId && this.Form.accountGroupName){
					paramObject.defaultValue = {"id":this.Form.accountGroupId, "name":this.Form.accountGroupName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);

			},

            fn_updateParentGroup: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.$nextTick(function(){
						this.Form.accountGroupId = selectedValueId;
						this.Form.accountGroupName = selectedValueName;
						this.fn_get(selectedValueId);
						this.errors.remove('parent group');
					})
				}
				else{
					this.Form.parentAccountGroupId = null;
		        	this.Form.parentGroupName = null;
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			
			comingSoon(){
				// this.snackbar = true;
				// this.snackbar_msg = "Coming Soon...";
				this.showToast("Coming Soon...");
			},

			fn_getFormData: function () {
				return this.Form;
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				//only for when android dialog calls from web dialog;
				if(ref.indexOf('dialog') != -1){
					let key = ref.substring(0, ref.lastIndexOf('_'));
					let dialogRef = this.$refs[key];
		
					var checkRefs = setInterval(function(){
			          if(dialogRef.$refs.hasOwnProperty(ref)){
			          	clearInterval(checkRefs);
			          	dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			          }
			        },50);

					// dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
				else if(this.$refs.hasOwnProperty(ref)){
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
				else{
					this.$refs['ref_fieldsForm'].fn_onChange(tagId, ref, selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				// dialogjs.fn_fixBackgroundScroll();
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_resetFieldData: function () {
				this.Form.fieldData = JSON.parse(JSON.stringify(require('../../fields/datamodel.js').data.fieldData));
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},
			
			// fn_checkValidations: function(){

			// 	var self = this;
			//     this.$validator.validateAll().then((result) => {
			//         if (result) {
			//         	// if(!self.Form.customerSupplierGroupData.selectedItems.length){
			//         	if(!this.Form.local && !this.Form.central && !this.Form.importExport){
			//         		self.invalidForm = true;
			//         		self.$vuetify.goTo('#transactionType_field', self.scrollOptions);
			//         		return;
			//         	}

			//         	if((this.typeName=='purchase' || this.typeName=='sale' || this.typeName=='expense') && !self.Form.isAllPartySelected && !self.Form.transactionParties.length){
			//         		// self.snackbar = true;
			//         		// self.snackbar_msg = "You have to choose minimum one "+this.labels.partyGroup.toLowerCase();
			//         		self.showToast("You have to choose minimum one "+this.labels.partyGroup.toLowerCase());
			//         		self.invalidForm = true;
			//         		self.$vuetify.goTo('#partyGroups_field', self.scrollOptions);
			//         		return;
			//         	}

			//            	self.fn_post();
			//           	return; 
			//         }
			//         else{
			//         	self.$vuetify.goTo('.error--text', this.scrollOptions);
			//         }
			//     });
			// },

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('PostAccountGroupSetting', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
						  self.showToast('Settings Updated');
						  self.fn_cleanUp();
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			

			fn_cleanUp: function () {

				// if(this.$route.query.ls){
				// 	let data = {};
				// 	data.type = 'transactionTypeForm';
				// 	data.id = this.Form.transactionTypeFormId;
				// 	data.name = this.Form.name;
				// 	localStorage.setItem('newItem', JSON.stringify(data));
				// 	localStorage.setItem('closeDialog', 1);
				// }

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.$router.go(-1);
				});
			},

			fn_checkValidations: function(){
				this.$validator.validateAll().then((result) => {
					if(result){
						if(!this.Form.isCustomized){
							// deleting data if isCustomized toggle removed from child by user
							if(this.Form.settingData && this.Form.settingData.isCustomized && !this.Form.isCustomized){
								this.fn_deleteSettings();
							}
							else{
								this.fn_goBack();
							}
						}
						else{
							this.fn_post();
						}
					}
				})
			},
			
			fn_post: function(){

                let postObj = {};
                postObj.accountGroupSettingId = this.guid();
                postObj.accountGroupId = this.Form.accountGroupId;
				postObj.isCustomized = this.Form.isCustomized;

				postObj.accountGroupSections = [];
				postObj.accountGroupFields = [];

				if(this.Form.fieldItems && this.Form.fieldItems.length && this.Form.fieldItems[0].fields && this.Form.fieldItems[0].fields.length){
						// fields
					for(let i=0; i<this.Form.fieldItems.length; i++){
						let sectionObj = {};
						sectionObj.accountGroupSectionId = this.guid();
						// sectionObj.sectionId = this.Form.fieldItems[i].section.sectionId ? this.Form.fieldItems[i].section.sectionId : this.guid();
						sectionObj.sectionId = this.guid();
						sectionObj.sectionName = this.Form.fieldItems[i].section.sectionName;
						sectionObj.isHidden = this.Form.fieldItems[i].section.isHidden;
						sectionObj.accountGroupId = this.Form.accountGroupId;
						sectionObj.accountGroupSettingId = postObj.accountGroupSettingId;
						sectionObj.orderNumber = 1;
						sectionObj.isSystem = 0;

						postObj.accountGroupSections.push(sectionObj);

						for(let j=0; j<this.Form.fieldItems[i].fields.length; j++){
							let fieldObj = {};

							//generating new field id if copy
							this.$route.query.copy ? this.Form.fieldItems[i].fields[j].accountGroupFieldId = this.guid() : '';

							// fieldObj.accountGroupFieldId = this.Form.fieldItems[i].fields[j].accountGroupFieldId;
							fieldObj.accountGroupFieldId = this.guid();
							fieldObj.fieldId = this.Form.fieldItems[i].fields[j].fieldId;
							fieldObj.displayName = this.Form.fieldItems[i].fields[j].displayName;
							fieldObj.isRequired = this.Form.fieldItems[i].fields[j].isRequired;
							fieldObj.isHidden = this.Form.fieldItems[i].fields[j].isHidden;
							fieldObj.additionalData = null;
							fieldObj.transactionTypeId = this.typeId;
							fieldObj.sectionId = sectionObj.sectionId;
							fieldObj.accountGroupSettingId = postObj.accountGroupSettingId;

							fieldObj.accountGroupId = this.Form.accountGroupId;
							fieldObj.isSystem = 0;

							fieldObj.listItemId = this.Form.fieldItems[i].fields[j].listItemId;

							fieldObj.accountLedgerId = this.Form.fieldItems[i].fields[j].accountLedgerId;
							postObj.accountGroupFields.push(fieldObj);
						}
					}
					
				}
				

				console.log(postObj);
				this.fn_saveLocal(postObj);
			},


			fn_get: function(itemId, copyData){
				var self = this;
				//sending current fiscalYear
				this.getData('GetAccountGroupSetting', itemId,
					{
						onSuccess: function(response){
				          	console.log(response);
				          	let data = null;

							if(response){
								self.Form.settingData = JSON.parse(response);
								data = JSON.parse(response);
								self.Form.accountGroupSettingId = data.accountGroupSettingId;
								data.isCustomized ? self.Form.isCustomized = data.isCustomized : '';
							}

							if(self.Form.isCustomized){
								if(data.accountGroupSections && data.accountGroupSections.length && data.accountGroupFields && data.accountGroupFields.length){
									let sections = data.accountGroupSections;
									let fields = data.accountGroupFields;
									// binding section and fields
									self.Form.fieldItems = [];
									for(let i=0; i<sections.length; i++){

										let obj = {};
										obj.section = JSON.parse(JSON.stringify(sections[i]));
										obj.fields = [];

										for(let j=0; j<fields.length; j++){
											if(sections[i].sectionId == fields[j].sectionId){
												obj.fields.push(fields[j]);
											}
										}

										self.Form.fieldItems.push(obj);
									}

									if(!sections || (sections && !sections.length)){
										self.Form.isCustomized = true;
										self.fn_assignSection();
									}
								}
								else{
									self.fn_assignSection();
								}
							}
							else{
								// with inheritance
								self.fn_getAccountGroupFields();
							}
							
							// //   check if item field added
							// if(data.transactionSections && (self.typeName == 'sale' || self.typeName == 'purchase' || self.typeName == 'expense')){
							// 	let itemIndex = data.transactionSections.findIndex(section => {
							// 		return section.sectionName == 'Item Details' && section.sectionType == 1;
							// 	});
								
							// 	if(itemIndex == -1){
							// 		self.fn_postItemDetailSection(data.transactionTypeFormId);
							// 	}
							// 	else{
							// 		self.fn_bindData(data, copyData);
							// 	}
							// }
							// else{
							// 	self.fn_bindData(data, copyData);
							// }
				          
				        }, 
				        onError: function(error){
				          console.log(error);
				          self.hideLoading();
				        }
					}
		        );
			},

			fn_bindData: function (data, copyData) {
				let self = this;

				this.Form.additionalData = data.additionalData;
				this.Form.centralTransactionAccountId = data.centralTransactionAccountId;
				this.Form.centralTransactionAccountName = data.centralTransactionAccountName;
				this.Form.importExportTransactionAccountId = data.importExportTransactionAccountId;
				this.Form.importExportTransactionAccountName = data.importExportTransactionAccountName;
				this.Form.isAllPartySelected = data.isAllPartySelected;
				this.Form.localTransactionAccountId = data.localTransactionAccountId;
				this.Form.localTransactionAccountName = data.localTransactionAccountName;
				this.Form.name = data.name;
				this.Form.numberSeriesId = data.numberSeries.numberSeriesId;
				this.Form.numberSeriesName = data.numberSeries.name;

				// if(data.printTemplateId){
				// 	this.Form.printTemplateId = data.printTemplateId;
				// 	this.Form.printTemplateName = data.printTemplateName;
				// }

				if(data.transactionTypePrints && data.transactionTypePrints.length){
					this.Form.printTemplateId = data.transactionTypePrints[0].printTemplateId;
					this.Form.printTemplateName = data.transactionTypePrints[0].printTemplateName;
				}

				this.Form.title = data.title;
				this.Form.local = data.local;
				this.Form.central = data.central;
				this.Form.importExport = data.importExport;
				this.Form.tradingType = data.tradingType;

				this.Form.transactionParties = JSON.parse(JSON.stringify(data.transactionParties));
				this.Form.transactionSections = JSON.parse(JSON.stringify(data.transactionSections));

				this.Form.addOnsProductLevel = [];
				this.Form.addOnsBillLevel = [];

				data.transactionTypeAddOns.forEach(function (item) {

					//generating new transactionTypeAddOnsId if copy data
					copyData ? item.transactionTypeAddOnsId = self.guid() : '';

					item.type == 0 ? self.Form.addOnsProductLevel.push(item) : self.Form.addOnsBillLevel.push(item);
				})


				this.Form.transactionTypeFields = JSON.parse(JSON.stringify(data.transactionTypeFields));
				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeId = data.transactionTypeId;

				if(this.typeName=='sale' && !this.invalidRoute){
					this.Form.taxMode = data.taxMode;
					this.Form.paymentMode = data.paymentMode;
					this.Form.salesGroupType = data.salesGroupType;
					this.Form.isRouteApplicable = data.isRouteApplicable;
				}

				this.Form.invoiceType = data.invoiceType;

				//incase of expense
				this.Form.inventory = data.inventory;

				//binding section and fields

				this.Form.fieldItems = [];
				for(let i=0; i<this.Form.transactionSections.length; i++){

					let obj = {};
					obj.section = JSON.parse(JSON.stringify(this.Form.transactionSections[i]));
					obj.fields = [];

					for(let j=0; j<this.Form.transactionTypeFields.length; j++){
						if(this.Form.transactionSections[i].sectionId == this.Form.transactionTypeFields[j].sectionId){
							obj.fields.push(this.Form.transactionTypeFields[j]);
						}
					}

					this.Form.fieldItems.push(obj);
				}

				if(copyData){
		          	this.Form.transactionTypeFormId = null;
					this.showToast("Transaction Form copied");
		        }

		        self.hideLoading();

			},

		
		

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;

				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newLedger'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb()}});
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='discounts'){
					this.$router.push({path:'/addons/discounts/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='taxes'){
					this.$router.push({path:'/addons/taxes/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='otherCharges'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='adddiscount' || menuAction=='addtaxes' || menuAction=='addothercharges'){
					let addOnsType = menuAction=='adddiscount' ? 1 : menuAction=='addtaxes' ? 2 : 3;
					this.fn_openAddOns(addOnsType, this.addOnsLevelType, true);
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			
			fn_showWebView: function () {
				var viewObject = {};

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "numberSeries":
					    	this.fn_setNumberSeries({numberSeriesId:itemData.id, name:itemData.name}, true);
					        break;
					    case "printTemplate":
					    	this.fn_setPrintTemplate({printTemplateId:itemData.id, name:itemData.name}, true);
					        break;
					    case "discounts":
					    case "taxes":
					    case "otherCharges":
					    	this.$refs['ref_dialogAddOns'].fn_updateAddOns(itemData.id, itemData.name, false);
					        break;
					    case "field":
					    	this.$refs['ref_fieldsForm'].fn_setFieldValue(itemData);
					        break;
						case "accountGroup":
					    	this.fn_updateAccountGroup(itemData.id, itemData.name, false);
					        break;

					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}
			},

			fn_assignSection: function () {
				let obj = {};
				let sectionObj = {"sectionId":null, "sectionName":"Custom Fields", "accountGroupId": null, "isHidden":false, "orderNumber":1, "isSystem":1};
				obj.section = JSON.parse(JSON.stringify(sectionObj));
				obj.fields = [];
				this.Form.fieldItems.push(obj);
			},	

			// with inheritance
			fn_getAccountGroupFields: function(){
				var self = this;
				console.log(this.Form.accountGroupId);
				this.Form.fieldItems = [];
				this.getData('GetAccountGroupSectionsAndFields', this.Form.accountGroupId, 
					{
						onSuccess: function(response){
				          console.log(response);
						  let data = response ? JSON.parse(response) : null;
						  self.Form.inheritedData = response ? JSON.parse(response) : null;
						  if(data && data.accountGroupSections && data.accountGroupSections.length && data.accountGroupFields && data.accountGroupFields.length){
							let obj = {};
							obj.section = JSON.parse(JSON.stringify(data.accountGroupSections[0]));
							obj.fields = JSON.parse(JSON.stringify(data.accountGroupFields));
							self.Form.fieldItems.push(obj);
							self.Form.nearestAccountGroupName = data.nearestAccountGroupName;
							self.Form.isInherited = data.isInherited;
						  }
						  else{
							self.Form.isCustomized = true;
							self.fn_assignSection();
						  }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getAccountSettings: function(){
				var self = this;
				this.getData('GetAccountGroupSetting', this.Form.accountGroupId, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_openAccountGroupsDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Account Group";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountGroupId && this.Form.accountGroupName){
					paramObject.defaultValue = {"id":this.Form.accountGroupId, "name":this.Form.accountGroupName};
				}

				viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id, accountGroupIds.creditors.id];

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);

			},

			fn_updateAccountGroup: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.$nextTick(function(){
						this.Form.accountGroupId = null;
						this.Form.accountGroupName = null;

						this.fn_clearData();

						this.Form.accountGroupId = selectedValueId;
						this.Form.accountGroupName = selectedValueName;
						this.fn_get(selectedValueId);
						this.errors.remove('parent group');
					})
				}
				else{
					this.Form.parentAccountGroupId = null;
		        	this.Form.parentGroupName = null;
				}
				this.$forceUpdate();
				this.fn_saveDraft(this.Form.name);
			},

			fn_clearData: function(){
				this.Form.accountGroupSettingsId = null;
				this.Form.additionalData = null;
				this.Form.fieldItems = [];
				this.Form.isCustomized = false;
				this.Form.nearestAccountGroupName = null;
				this.Form.isInherited = false;
				this.Form.settingData = null;
			},

			fn_deleteSettings: function(){
				let self = this;
				this.deleteData("DeleteAccountGroupSetting", this.Form.accountGroupId, {
					onSuccess: function(response){
						console.log(response);
						self.showToast('Fields reset done');
						self.fn_goBack();
					}, 
					onError: function(error){
						console.log(error);
					}
				}); 
			},
			
			fn_goBack: function(){
				this.backButtonPress = true;
				this.fn_draftAction(true, true);
				// this.$router.go(-1);
			},

			fn_openDialogConfirmation: function(value){
				if(value){
					this.confirmationHeader = "Customize Fields";
					this.confirmationMessage = "Customize own fields for this group. You can add more fields or remove existing."
				}
				else{
					this.confirmationHeader = "Inherit Fields from Parent";
					this.confirmationMessage = "Customized fields will be removed and inherit from its parent group (If added any)"
				}
				this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation');
			},

			fn_resetFields: function(){
				if(!this.Form.isCustomized){
					this.fn_clearData();
					this.fn_getAccountGroupFields();
				}
				else{
					this.Form.isInherited = false;
					this.Form.nearestAccountGroupName = null;
				}
				// else{
				// 	this.fn_clearData();
				// 	this.fn_getAccountGroupFields();
				// }
				this.fn_closeDialog();
			},

			fn_cancelCustomizeToggle: function(){
				this.Form.isCustomized = !this.Form.isCustomized;
				this.fn_closeDialog();
			}

		},
		mounted: function(){

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// this.Form.accountGroupId = this.$route.params.tagId ? this.$route.params.tagId : null;
			// this.Form.accountGroupName = this.$route.query.name ? this.$route.query.name : null;

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			
			this.fn_showWebView();


			// if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				
			// }

			var self = this;
			// this.fn_setFormDataFromLocalStorage();
			this.fn_setFormDataFromDraft(function(draft){

				if(draft){
					self.Form = JSON.parse(draft.formData);	
				}
				// else{
				// 	if(!self.Form.accountGroupId){
				// 		self.fn_openAccountGroupsDialog('android', 'AccountGroups', 'field_accountGroups');
				// 	}
				// }
				
			});

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', this.toolBarTitle);
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		if(localStorage.getItem('closeDialog')){
					vm.fn_closeDialog();
					localStorage.removeItem('closeDialog');
				}
				else{
					dialogjs.fn_checkAndShowOpenDialogs(vm);
				}
		  		// dialogjs.fn_checkAndShowOpenDialogs(vm);
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from list view
		  		if(from.name=='transactionTypeItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'transactionTypeItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  				copyData = true;
		  			}
		  		}

		  		if(itemId){
		  			let self = vm;
		  			self.showLoading('Please wait...');
		  			setTimeout(function(){
		  				self.fn_get(itemId, copyData);
		  			},100);
		  		}

		  	})
		},

		beforeRouteUpdate (to, from, next) {
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('transTypeForms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },

		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					this.backButtonPress = false;
					next(false);
				}
				else{
					next(true);
				}
			}
			else{
				localStorage.removeItem('transTypeForms');
				next();
			}
	    }

	}

</script>

<style>
.list-item {
  // display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all .5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>


// WEBPACK FOOTER //
// src/components/settings/account_groups/form.vue